<template>
  <div v-if="showsSystemErrorNotice">
    <div v-if="showsDisabled">
      <div class="title-notice">
        <div v-html="replaceKaigyo(systemErrorNotice.title_disabled)"></div>
      </div>
      <div class="message-notice">
        <div v-html="replaceKaigyo(systemErrorNotice.message_disabled)"></div>
      </div>
    </div>
    <div v-else>
      <div :class="{ title_with_space: onlyTitleInError }" class="title-notice">
        <div v-html="replaceKaigyo(systemErrorNotice.title_in_error)"></div>
      </div>
      <div v-if="!onlyTitleInError" class="message-notice">
        <div v-html="replaceKaigyo(systemErrorNotice.message_in_error)"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, createComponent, onCreated, PropType, value, Wrapper } from "vue-function-api";
import { SystemErrorNotice } from "@/modules/admin/objects/systemErrorNotice";
import { defaultSystemErrorNotice, getSystemErrorNotice } from "@/modules/admin/services/systemErrorNotice";
import { i18n } from "@/framework/plugins/i18n";
import { replaceKaigyo } from "@/framework/utilities/replaceKaigyo";

export default createComponent({
  props: ["onlyTitleInError", "showsDisabled"] as any as PropType<{
    onlyTitleInError: Boolean;
    showsDisabled: Boolean;
  }>,
  setup(props, context) {
    const systemErrorNotice: Wrapper<SystemErrorNotice> = value(defaultSystemErrorNotice());
    const showsSystemErrorNotice = computed(() => systemErrorNotice.value.system_status !== "WORKING");
    const goesToDisabledPage = () => !props.showsDisabled && systemErrorNotice.value.system_status == "DISABLED";
    const goesToSignInPage = () => props.showsDisabled && systemErrorNotice.value.system_status != "DISABLED";

    onCreated(async () => {
      systemErrorNotice.value = await getSystemErrorNotice();

      if (goesToDisabledPage()) {
        context.root.$router.push({ path: `/${i18n.locale}/system/disabled` });
      } else if (goesToSignInPage()) {
        context.root.$router.push({ path: `/${i18n.locale}/signin/admin` });
      }
    });

    return { showsSystemErrorNotice, systemErrorNotice, replaceKaigyo };
  },
});
</script>

<style scoped lang="scss">
.title_with_space {
  padding: 15px 40px;
}

.title-notice {
  font-weight: 600;
  line-height: 1.8;
}

.message-notice {
  margin-top: 10px 0;
  line-height: 1.8;
}
</style>
